import { HubConnectionBuilder, HubConnection, HttpTransportType } from "@microsoft/signalr";


class SignalRServiceModel {
	static connectionSpeakcom: HubConnection;
	static connectionServer: HubConnection;
	static lastTreatment: string;
	connected: boolean = false;
	apiUrl_dm = localStorage.getItem('apiUrl');
	constructor(apiUrl: string | undefined) {

		if (apiUrl) {
			this.connectToSpeakComHub(apiUrl);
		} else {
			this.connectToServerHub(this.apiUrl_dm || undefined)
		}
	}

	static setLastTreatment(treatment: string) {
		// 
		console.log('SignalRServiceModel setLastTreatment', treatment);
		if (typeof treatment === 'string') {
			SignalRServiceModel.lastTreatment = treatment;
		}
	}

	connectToSpeakComHub(apiUrl: string | undefined) {

		if (SignalRServiceModel.connectionSpeakcom === null || SignalRServiceModel.connectionSpeakcom === undefined) {
			SignalRServiceModel.connectionSpeakcom = new HubConnectionBuilder()
				.withUrl(apiUrl + "/UserAccountHub", { skipNegotiation: true, transport: HttpTransportType.WebSockets })
				// .withAutomaticReconnect()
				.build();
			// console.log("Websocket 1");
			SignalRServiceModel.connectionSpeakcom.start().then(() => {
				//console.log('SignalR connected');
				this.connected = true;
				SignalRServiceModel.connectionSpeakcom.on('UserConnected', message => {
					// console.log("SignalR UserConnected", message);
				});


				const userId = this.getUserId();

				console.log('origin', window.location.origin)
				SignalRServiceModel.connectionSpeakcom.invoke("SaveUserId", `${this.getUserId()};${window.location.origin}`);
			}).catch((error) => {
				console.log("Websocket error");
				console.error("Websocket Error: " + error);
			});


			// SignalRServiceModel.connectionSpeakcom.onreconnecting(error => {
			// 	console.log("Reconnecting...", error);
			// });

			// SignalRServiceModel.connectionSpeakcom.onreconnected(connectionId => {
			// 	console.log("Reconnected!", connectionId);
			// });

			// SignalRServiceModel.connectionSpeakcom.onclose(error => {
			// 	console.error("Connection closed!", error);
			// 	// You can also trigger a manual reconnect if needed
			// });
		}


	}

	connectToServerHub(apiUrl: string | undefined) {

		if (SignalRServiceModel.connectionServer === null || SignalRServiceModel.connectionServer === undefined) {
			SignalRServiceModel.connectionServer = new HubConnectionBuilder()
				.withUrl(apiUrl + "/UserAccountHub", { skipNegotiation: true, transport: HttpTransportType.WebSockets })
				// .withAutomaticReconnect()
				.build();
			// console.log("Websocket 1");
			SignalRServiceModel.connectionServer.start().then(() => {
				//console.log('SignalR connected');
				this.connected = true;
				SignalRServiceModel.connectionServer.on('UserConnected', message => {
					// console.log("SignalR UserConnected", message);
				});

				const userId = this.getUserId();
				SignalRServiceModel.connectionServer.invoke("SaveUserId", this.getUserId());
			}).catch((error) => {
				console.log("Websocket error");
				console.error("Websocket Error: " + error);
			});
		}
	}


	getSpeakComConnection() {
		return SignalRServiceModel.connectionSpeakcom;
	}
	getServerConnection() {
		return SignalRServiceModel.connectionServer;
	}

	init() {
		if (this.connected) {
		} else {
			//console.log('SignalR is not connected');
		}

	}

	getUserId() {
		const parsedData = localStorage.getItem('loggedUser');
		if (parsedData) {
			const loggedUser = JSON.parse(parsedData)
			return loggedUser.id;
		}
		return "";
	}


	// Add methods for sending and receiving messages/events
}

export default SignalRServiceModel;